(function () {
  function initEvolvePills() {
    document.querySelectorAll('.evolve-pills-wrap').forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        const pill = e.target.closest('.evolve-pill');
        if (!pill) return;

        const optionIndex = parseInt(pill.dataset.optionIndex, 10);
        const optionValue = pill.dataset.optionValue;
        const variantSelects = pill.closest('variant-selects');
        if (!variantSelects) return;

        // Update pill states
        wrap.querySelectorAll('.evolve-pill').forEach(function (p) {
          p.classList.remove('evolve-pill--selected');
          p.setAttribute('aria-checked', 'false');
          const swatch = p.querySelector('.evolve-pill__swatch');
          if (swatch) {
            swatch.classList.remove('evolve-pill__swatch--selected');
            const tick = swatch.querySelector('.evolve-pill__tick');
            if (tick) tick.remove();
          }
        });

        pill.classList.add('evolve-pill--selected');
        pill.setAttribute('aria-checked', 'true');
        const selectedSwatch = pill.querySelector('.evolve-pill__swatch');
        if (selectedSwatch) {
          selectedSwatch.classList.add('evolve-pill__swatch--selected');
          if (!selectedSwatch.querySelector('.evolve-pill__tick')) {
            selectedSwatch.insertAdjacentHTML('beforeend',
              '<svg class="evolve-pill__tick" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M2 5.5L4 7.5L8 3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            );
          }
        }

        // Trigger the theme's variant selection on the matching option select
        const selects = variantSelects.querySelectorAll('select');
        const select = selects[optionIndex] || selects[0];
        if (select) {
          select.value = optionValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEvolvePills);
  } else {
    initEvolvePills();
  }
})();
